var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"rd-panel",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"font-weight-bold"},[_vm._v(" Статус подключения: "+_vm._s(_vm.localizeStatus(_vm.connectionState))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }